import {h, Fragment} from "preact"
import { useAppState } from '@nosto/preact';
import { getTranslation } from '../translation';

export default function NoResults() {
    const {
        response: { query },
    } = useAppState();

  
    return (
        <div class="ns-justify-content-center ">
            <div class="ns-font-4 ns-text-align-center">
                <span class="h2">
                    {getTranslation('No results found for')} '{query}'
                </span>
            </div>
        </div>
    );
}
